import { render, staticRenderFns } from "./puPlanListAction.vue?vue&type=template&id=45ff4453&scoped=true"
import script from "./puPlanListAction.vue?vue&type=script&lang=js"
export * from "./puPlanListAction.vue?vue&type=script&lang=js"
import style0 from "./puPlanListAction.vue?vue&type=style&index=0&id=45ff4453&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ff4453",
  null
  
)

export default component.exports